/* eslint-disable react-refresh/only-export-components */
import { Button } from "@/components/ui/button";
import React from "react";

export enum NotificationAllSaveSwitcherType {
  ALL = "all",
  SAVE = "save",
}

const NotificationAllSaveSwitcher = ({
  type = NotificationAllSaveSwitcherType.ALL,
  setType,
}: {
  type: NotificationAllSaveSwitcherType;
  setType: (type: NotificationAllSaveSwitcherType) => void;
}) => {
  return (
    <div className="mb-1 flex items-center overflow-hidden rounded-md border p-1">
      <Button
        variant="link"
        className={`relative w-20 text-black transition-all duration-200 ${
          type === NotificationAllSaveSwitcherType.ALL
            ? "bg-primary font-semibold text-white"
            : "hover:bg-gray-100"
        } hover:no-underline`}
        onClick={() => setType(NotificationAllSaveSwitcherType.ALL)}
      >
        <span className="relative z-10">All</span>
        {type === NotificationAllSaveSwitcherType.ALL && (
          <div className="absolute inset-0 border transition-all duration-200" />
        )}
      </Button>

      <Button
        variant="link"
        className={`relative w-20 text-black transition-all duration-200 ${
          type === NotificationAllSaveSwitcherType.SAVE
            ? "bg-primary font-semibold text-white"
            : "hover:bg-gray-100"
        } hover:no-underline`}
        onClick={() => setType(NotificationAllSaveSwitcherType.SAVE)}
      >
        <span className="relative z-10">Saved</span>
        {type === NotificationAllSaveSwitcherType.SAVE && (
          <div className="absolute inset-0 border transition-all duration-200" />
        )}
      </Button>
    </div>
  );
};

export default NotificationAllSaveSwitcher;
